import { Link } from "react-router-dom";
import { methodSteps } from "@/mocks/content";

export default function MethodBand() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="rounded-xl border border-primary-100 bg-primary-50 p-6 md:p-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <p className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-route-line text-sm" aria-hidden="true"></i>
              吃瓜方法论 · 四条路线
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              如何吃透一个瓜，而不是被瓜带偏
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              看热闹谁都会，理清楚才是本事。一套可复用的整理方法：找源头 → 建时间线 → 辨立场 → 溯源查证，四步走完，结论自己会浮现。
            </p>
            <Link
              to="/methodology"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              学习完整方法论
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="grid flex-1 grid-cols-2 gap-3 lg:max-w-xl lg:grid-cols-4">
            {methodSteps.map((s) => (
              <div
                key={s.step}
                className="rounded-lg border border-primary-100 bg-background-50 p-4 text-center transition-colors hover:border-primary-200"
              >
                <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="mt-3 block font-heading text-sm font-bold text-primary-800">
                  {s.step} · {s.title}
                </span>
                <span className="mt-1 block text-xs leading-relaxed text-foreground-500">{s.action}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}